import React from 'react'

import { Divider, Typography } from 'antd'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

const { Title } = Typography

@connect((state) => ({
  //decorator, gives component access to the state
  userId: state.user.info.id,
  email: state.user.info.email,
  role: state.user.info.role
}))
class FAQFrame extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      url: '',
      title: ''
    }

    function getFrameId(props) {
      const locationArry = props.location.pathname.split('/')
      let id_str = locationArry[locationArry.length - 1].split('-')[0]
      return id_str
    }

    let frameId = getFrameId(this.props)
    console.log(frameId)
    if (frameId === '1') {
      this.state.url = '2PACX-1vTiVQvP7Fx59G29B6DApI15RQQEHqBuSgVMUr9rJzUOiM2DQ6NZnO6VZf5nD_CRuXaMuIB-SDSXvtum'
      this.state.title = '1.Manage Artworks'
    }
    if (frameId === '1.1') {
      this.state.url = '2PACX-1vTiVQvP7Fx59G29B6DApI15RQQEHqBuSgVMUr9rJzUOiM2DQ6NZnO6VZf5nD_CRuXaMuIB-SDSXvtum'
      this.state.title = '1.Add/Edit/Delete'
    }
    if (frameId === '1.2') {
      this.state.url = '2PACX-1vSrqbJEppsb8hz2GGWa7tY5toe7Cc258rNoMLEzUJHtjFzEhoiqYWF_RZuIe1eQ1Dt7nlbeWz1oi4ky'
      this.state.title = '2.Inventory Report'
    }
    if (frameId === '1.3') {
      this.state.url = '2PACX-1vQCCk5LB8qofK3oISXnUnR20qqmDt3YZs2s2arLPw0mbDsqmxROldc7gYwBGNP-w4jvelu2QcBXDwB4'
      this.state.title = '1.3 Bulk Uploads'
    }
    if (frameId === '2.' || frameId === 2) {
      this.state.url = '2PACX-1vT86E-5hOPVo-7MX_vqmTJkmxG1IVkM_IL0-4Vc79WqWzuWsuPjFVlLqT8zokrP3IoKRyvQHwNlQ0Ah'
      this.state.title = '2.Manage The Showcase'
    }
    if (frameId === '3.' || frameId === 3) {
      this.state.url = '2PACX-1vRDut1mSZreWoz8sQ86-hmtQTm3pG6Ua8T_jsgF_A9cYjnXkqFjCuDYq6m7wcfPyI8wOUb6JjwXMz2P'
      this.state.title = '3.Manage Agreements'
    }
    if (frameId === '4.' || frameId === 4) {
      this.state.url = '2PACX-1vTusWx-EqjvgPswa5_Kc3zJB2agUCTQRERQlhmrBV7vapIEJngBeMCc52RsGuc8Ek96AuKf-3dmW9AY'
      this.state.title = '4.Troubleshooting'
    }
    if (frameId === '5.' || frameId === 5) {
      this.state.url = '2PACX-1vRSPukQBwUmRfU6QBZf3LdCTRjUwF8VjyjsEjp50nDOmepnKz1a2jFu7Vgq82H-tjGprL_Rfv3ZIxK-'
      this.state.title = '5.Participate In Print Business'
    }
  }

  render() {
    return (
      <div>
        <a href={'/sam/faqs/'} style={{ float: 'right' }}>
          Back to FAQs
        </a>
        <Title>{this.state.title}</Title>
        <Divider orientation='left' />
        <iframe
          src={'https://docs.google.com/document/d/e/' + this.state.url + '/pub?embedded=true'}
          title={this.state.title}
          width='100%'
          height='600'
        />
      </div>
    )
  }
}

export default withRouter(FAQFrame)
